import { useState } from "react";
import { FaSort } from "react-icons/fa6";
import { IoDocumentAttachOutline } from "react-icons/io5";
import { getDateFormatString } from "../../../utils";
import styles from "../style.module.scss";
import { RiRobot2Fill } from "react-icons/ri";
import { BiCheckCircle } from "react-icons/bi";
import { AiOutlineCloseCircle } from "react-icons/ai";
import AIEvaluationPopup from "./ReviewResponseModel/AIEvaluationPopup";
import type { AIEvaluation } from "./ReviewResponseModel/ReviewResponseModel.types";
import { Sparkles } from "lucide-react";
interface ConversationType {
  conversationId: number;
  askedBy: string;
  askedOn: string | null;
  question: string;
  response: string | null;
  complianceStatus: boolean | null;
  aiValidation: {
    satisfactory: string;
    followupQuestions: string[];
    reason: string;
  } | null;
  responseValidationRequired: boolean;
  reason: string | null;
  questionCode: string;
  documents: { fileName: string }[];
  respondedOn: string | null;
  responseValidatedOn: string | null;
  responseValidatedBy: any | null;
}

interface ResponseTableProps {
  conversations: ConversationType[];
  columns: { label: string; key: string }[];
  responseValidationRequired: Boolean;
}

const ResponseTable = ({ conversations, columns, responseValidationRequired }: ResponseTableProps) => {
  const [selectedEvaluation, setSelectedEvaluation] = useState<AIEvaluation | null>(null);

    const getStatusIcon = (status: any) => {
    if (status === null) return "";
    return status ? (
      <BiCheckCircle size={18} />
    ) : (
      <AiOutlineCloseCircle size={18} />
    );
  };

  const handlePopUp = (conv: ConversationType) => {
    if (conv.aiValidation) {
      const evaluation: AIEvaluation = {
        status: conv.aiValidation.satisfactory === "yes" ? "Satisfied" : "Not Satisfied",
        reason: conv.aiValidation.reason,
        timestamp: conv.respondedOn || "",
      };
      setSelectedEvaluation(evaluation);
    }
  };
  return (
    <>
    {selectedEvaluation && (
      <AIEvaluationPopup
        evaluation={selectedEvaluation}
        onClose={() => setSelectedEvaluation(null)}
      />
    )}
    <table className={styles.responseTable}>
      <thead>
        <tr>
          {columns.map(({ label, key: columnKey }) => (
            <th key={columnKey}>
              {label} <FaSort color="#9ca3af" size={10} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {conversations.map((conv, index, arr) => {
          const isAI = conv.askedBy === "AI";
          const isFollowup = index > 0;
          const followupNumber = isFollowup ? index : 0;
          return (
            <tr
              key={conv.conversationId}
              style={{
                backgroundColor: isFollowup ? "#fef9e7" : "transparent",
              }}
            >
              {/* S/No */}
              <td
                style={{
                  textAlign: "center",
                  width: "80px",
                }}
              >
                {isFollowup ? (
                  <span className={styles.followupBadge}>
                    Followup {followupNumber}
                  </span>
                ) : (
                  index + 1
                )}
              </td>
              {/* Question */}
              <td style={{ maxWidth: "250px" }}>
                <span className={styles.responseText}>{conv.question}&nbsp;
                  {isAI && (
                      <RiRobot2Fill
                          className="float-end"
                          style={{
                          fill: "#1C2653",
                          }}
                      />
                   )}</span>
              </td>
              {/* Auditee Response */}
              <td style={{ maxWidth: "300px" }}>
                {conv.response ? (
                  <span className={styles.responseText}>{conv.response}</span>
                ) : (
                  <span className={styles.awaitingResponseText}>
                    Awaiting Response
                  </span>
                )}
              </td>
              {/* Responded On */}
              <td>
                <span className={styles.respondedOnText}>
                  {conv.respondedOn
                    ? getDateFormatString(conv.respondedOn, "DD/MM/YYYY, h.mma")
                    : "-"}
                </span>
              </td>
              {/* Documents */}
              <td>
                {conv.documents?.length > 0
                  ? conv.documents.map((doc, docIndex) => (
                      <div key={docIndex}>
                        <IoDocumentAttachOutline /> {doc.fileName}
                      </div>
                    ))
                  : "-"}
              </td>
              {/* Evaluation */}
              <td style={{ textAlign: "center" }}>
                {conv.response && conv.complianceStatus !== null && (
                  <span
                    className={`${
                      conv.complianceStatus
                        ? styles.complaint
                        : styles.nonComplaint
                    }`}
                  >
                   {getStatusIcon(conv.complianceStatus)}
                   &nbsp;
                   {conv.complianceStatus
                   ? "Satisfied"
                   : "Not Satisfied"}
                  </span>
                )}
                {responseValidationRequired && conv.responseValidatedOn !== null &&(
                  <span onClick={() => handlePopUp(conv)} style={{ cursor: "pointer" }}>
                    &nbsp;<Sparkles className="text-blue-500" size={20} />&nbsp;
                  </span>
                )}
              </td>
              {/* Reason */}
              <td style={{ maxWidth: "250px" }}>{conv.reason || (conv.aiValidation?.reason )|| "-"}</td>
              {/* Evaluated By */}
              <td>{conv.responseValidatedOn && conv.responseValidatedBy!==null?conv.responseValidatedBy?.name :
               conv.responseValidatedOn!==null &&conv.responseValidatedBy===null?"AI":"-"}</td>
              {/* Evaluated On */}
              <td>
                <span className={styles.respondedOnText}>
                  {conv.responseValidatedOn !== null
                    ? getDateFormatString(
                        conv.responseValidatedOn,
                        "DD/MM/YYYY, h.mma",
                      )
                    : "-"}
                </span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    </>
  );
};

export default ResponseTable;